const CurrencyFormatter = (currency: string) => {
    let formatter;
    //Byg formatter opbjekt op efter currency
    switch (currency) {
        case 'DKK':
            formatter = new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' });
            break;
        case 'EUR':
            formatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
            break;
        case 'USD':
            formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', });
            break;
        default:
            formatter = new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' });
            break;
    }

    return formatter;
}

export default CurrencyFormatter